import React from 'react';

export default function Welcome() {
  return (
    <section className="section auth">
      <div className="container">
        <h1>Welcome to Plant Companion!</h1>
        <p>You have successfully registered a new account.</p>
        <p>Please confirm your account using the link in the email we sent to you!</p>
      </div>
    </section>
  )
}
